var _rect, _rect2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.902344,
    y: 0.109375,
    width: 75,
    height: 75,
    rx: 5,
    fill: "#E1F7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.625,
    y: 1.83203,
    width: 71.7773,
    height: 71.7773,
    rx: 4.5,
    stroke: "url(#paint0_linear_182_1812)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9204 63.4311C43.2722 63.4311 33.9955 59.8661 25.0713 50.942C13.6401 39.5108 11.0012 27.4983 13.3869 21.1756C15.0932 16.6547 19.8517 15.1771 22.5358 14.6991C23.3669 14.5535 24.2228 14.6815 24.9749 15.064C25.727 15.4464 26.3347 16.0627 26.7066 16.8201L30.8748 25.3864C31.6227 26.9235 31.2623 28.8003 29.9965 29.9498L26.4521 33.17C26.5929 34.3144 27.4725 37.8497 32.8187 43.1946C38.1443 48.5214 41.6731 49.4127 42.8472 49.5586L46.0635 46.0182C46.6292 45.4014 47.3782 44.983 48.1999 44.8246C49.0217 44.6662 49.8726 44.7763 50.627 45.1386L59.1933 49.3068C59.951 49.6783 60.5675 50.2859 60.95 51.0381C61.3325 51.7903 61.4603 52.6464 61.3142 53.4776C60.8363 56.1616 59.3586 60.9201 54.8391 62.6264C53.4518 63.1496 51.7907 63.4311 49.9204 63.4311Z",
    fill: "url(#paint1_linear_182_1812)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1779 31.6053L30.0017 29.9494C30.6187 29.3839 31.0373 28.6348 31.1955 27.8129C31.3537 26.991 31.2431 26.1401 30.88 25.3859L26.7118 16.8196C26.3394 16.0626 25.7317 15.4468 24.9797 15.0644C24.2278 14.682 23.3721 14.5537 22.541 14.6987C21.9094 14.8111 21.1577 14.9854 20.3633 15.236C22.1305 21.0545 24.7642 26.573 28.1779 31.6053ZM59.1972 49.3063L50.6309 45.1381C49.8766 44.7754 49.0256 44.6651 48.2038 44.8235C47.3819 44.9819 46.6329 45.4006 46.0674 46.0177L44.4115 47.8403C49.4435 51.2537 54.9616 53.8886 60.7795 55.6562C61.0288 54.8618 61.2045 54.11 61.3169 53.4784C61.4634 52.6472 61.3358 51.791 60.9532 51.0387C60.5706 50.2864 59.9539 49.6788 59.196 49.3076L59.1972 49.3063Z",
    fill: "#8725D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1907 37.9472C51.8154 38.0503 51.5952 38.4375 51.6983 38.8128C51.8014 39.188 52.1885 39.4083 52.5638 39.3052C57.4307 37.9678 62.4785 40.8395 63.8159 45.7063C63.919 46.0816 64.3061 46.3019 64.6814 46.1987C65.0567 46.0956 65.2769 45.7085 65.1738 45.3332C63.6306 39.7171 57.8068 36.404 52.1907 37.9472ZM52.937 40.6631C52.5617 40.7662 52.3414 41.1533 52.4446 41.5286C52.5477 41.9039 52.9348 42.1242 53.3101 42.021C56.6797 41.0951 60.174 43.083 61.1 46.4526C61.2031 46.8279 61.5902 47.0481 61.9655 46.945C62.3408 46.8419 62.561 46.4548 62.4579 46.0795C61.3263 41.9613 57.0552 39.5315 52.937 40.6631Z",
    fill: "url(#paint2_linear_182_1812)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_182_1812",
    x1: 38.5137,
    y1: 1.33203,
    x2: 38.5137,
    y2: 74.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#C8EDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_182_1812",
    x1: 36.9775,
    y1: 14.6406,
    x2: 36.9775,
    y2: 63.4311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007BD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_182_1812",
    x1: 52.4384,
    y1: 37.8105,
    x2: 70.8282,
    y2: 37.7492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8725D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.55a1c0e8ce909b2369c417550f8b37f7.svg";
export { ForwardRef as ReactComponent };